<script setup lang="ts">
   import { useAuth0 } from '@auth0/auth0-vue';
   import useAuthStore from '~/stores/auth';
   import { computed } from 'vue';
   import { clearLoggedIn, clearPostLoginRedirect } from '~/composables/usePostLoginRedirect';
   import { useRuntimeConfig } from '#imports';
   import { resolveAuthLogoutReturnTo } from '~/functions/appOrigin';
   import { nativeAuthOpenUrl } from '~/functions/nativeAuthBrowser';
   //store
   const { user } = useAuthStore();
   const config = useRuntimeConfig();
   //props
   const { location, hideButtonText } = defineProps<{
      hideButtonText?: boolean;
      location: 'mainNav' | 'userMenu';
   }>();

   const { logout } = useAuth0();

   const logoutRedirectUrl = computed(() => {
      if (user?.site_settings?.portal === 'uspa') {
         return 'https://members.uspolo.org/';
      }
      // Web: window.location.origin (unchanged). Native: the Auth0 custom-scheme
      // callback, since there is no URL to come back to. See functions/appOrigin.ts.
      return resolveAuthLogoutReturnTo(config.public.auth0Domain as string);
   });
   const userLogout = () => {
      clearLoggedIn();
      clearPostLoginRedirect();
      logout({
         logoutParams: {
            returnTo: logoutRedirectUrl.value,
         },

         // Same reasoning as login: without this the WebView navigates to Auth0's logout
         // endpoint and the user is left on a remote page inside a chrome-less app.
         // `undefined` on the web. See functions/nativeAuthBrowser.ts.
         openUrl: nativeAuthOpenUrl(),
      });
   };
</script>

<template>
   <Button
      @click="userLogout"
      v-if="location === 'userMenu'"
      class="w-full pl-4"
      title="Log out">
      <span class="pi pi-sign-out"></span>
      <span class="ml-2" v-if="!hideButtonText">Log Out</span>
   </Button>
   <a
      @click="userLogout"
      v-if="location === 'mainNav'"
      class="flex w-full cursor-pointer items-center justify-between border-b-[3px] border-transparent bg-transparent p-3 text-xs font-bold uppercase text-gray-400 hover:border-brand-primary hover:text-black">
      Log Out
   </a>
</template>

<style scoped></style>
